import { render, staticRenderFns } from "./scratchCard.vue?vue&type=template&id=574ba33e&scoped=true&"
import script from "./scratchCard.vue?vue&type=script&lang=js&"
export * from "./scratchCard.vue?vue&type=script&lang=js&"
import style0 from "./scratchCard.vue?vue&type=style&index=0&id=574ba33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ba33e",
  null
  
)

export default component.exports